<template>
  <div
    class="video-container"
    :class="{ 'hide-control': !controls, 'hide-loading': hideLoading }"
  >
    <div :id="id" class="video-box"></div>
  </div>
</template>

<script>
import flvjs from 'flv.js'
import Hls from 'hls.js'
import Artplayer from 'artplayer'

// 关闭flv全部日志
flvjs.LoggingControl.enableAll = false

export default {
  props: {
    url: {
      type: String,
      default: ''
    },
    controls: {
      type: Boolean,
      default: true
    },
    autoplay: {
      type: Boolean,
      default: false
    },
    poster: {
      type: String,
      default: ''
    },
    option: {
      type: Object,
      default: () => ({})
    },
    // 假如页面里同时存在多个播放器，是否只能让一个播放器播放
    mutex: {
      type: Boolean,
      default: false
    },
    mini: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      id:
        'video-' +
        Math.random()
          .toString(36)
          .slice(2, 8),
      hideLoading: false
    }
  },
  watch: {
    url() {
      this.init()
    }
  },
  mounted() {
    this.init()
  },
  beforeUnmount() {
    this.destroy()
  },
  methods: {
    init(src = '') {
      const url = this.url || src
      if (!url) return
      this.destroy()
      this.$nextTick(() => {
        this.play(url)
      })
    },
    play(url) {
      const art = (this._art = new Artplayer({
        container: document.querySelector('#' + this.id),
        url,
        poster: this.poster,
        playsInline: true,
        ...this.getOption(url),
        customType: this.getCustomType(),
        controls: [],
        contextmenu: [
          {
            html: '全屏',
            click() {
              art.fullscreen = !art.fullscreen
              art.contextmenu.show = false
            }
          }
        ]
      }))
      this.$emit('ready', art)
      art.on('video:play', () => {
        this.hideLoading = true
      })
      art.on('loadeddata', function() {
        // 确保视频已加载第一帧
        art.screenshot().then(function(url) {
          console.log(url, 'url11111111')
          // 将截图设置为海报图
          art.poster = url
        })
      })
      art.on('destroy', () => {
        this.cleanup(art)
      })
    },
    getCustomType() {
      return {
        hls(video, url) {
          this._art.__hls?.destroy()
          const hls = new Hls()
          hls.loadSource(url)
          hls.attachMedia(video)
          this._art.__hls = hls
        },
        flv(video, url) {
          this._art.__flv?.destroy()
          const flv = flvjs.createPlayer(
            {
              type: 'flv',
              hasAudio: false,
              url: url
            },
            {
              stashInitialSize: 1000,
              autoCleanupSourceBuffer: true
            }
          )
          flv.attachMediaElement(video)
          flv.load()
          this._art.__flv = flv
        }
      }
    },
    cleanup(art) {
      if (art.__flv) {
        art.__flv.pause()
        art.__flv.unload()
        art.__flv.detachMediaElement(art.__flv._mediaElement)
        art.__flv.destroy()
        art.__flv = null
      }
      art.__hls?.destroy()
    },
    getOption(url) {
      const type = this.getType(url)
      const autoplay = this.autoplay
      const miniOption = this.mini
        ? {
            setting: false,
            screenshot: true,
            pip: false,
            fullscreen: true,
            fullscreenWeb: false
          }
        : {
            screenshot: true
          }
      return {
        type,
        autoplay: autoplay,
        isLive: !!type,
        setting: true,
        screenshot: true,
        autoMini: false,
        flip: true,
        aspectRatio: true,
        pip: true,
        fullscreen: true,
        fullscreenWeb: true,
        mutex: this.mutex,
        ...miniOption,
        ...this.option
      }
    },
    getType(url) {
      if (/hls|m3u8/.test(url)) return 'hls'
      if (/flv/.test(url)) return 'flv'
      return ''
    },
    destroy() {
      this._art?.destroy?.()
      this._art = null
      this.hideLoading = false
    }
  }
}
</script>

<style scoped lang="scss">
.video-container {
  position: relative;
  z-index: 0;
  &::before {
    content: '';
    display: block;
    padding-bottom: 56.25%;
  }
  > .video-box {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: #000;
  }
  .poster-box {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
}
.hide-control ::v-deep .art-bottom {
  display: none !important;
}
.hide-loading ::v-deep .art-loading {
  display: none !important;
}
.video-box ::v-deep .art-video-player {
  .art-video {
    pointer-events: none;
  }
  .art-state {
    bottom: calc(50% - 30px);
    right: calc(50% - 30px);
  }
  .art-icon-state {
    svg {
      width: 40px;
    }
  }
  .art-progress-indicator {
    width: 10px !important;
    height: 10px !important;
    background: #fefefe !important;
  }
}
</style>
